import React, { useState } from "react";
import { Form, Input, Select } from "antd";
import FormModal from "../../../components/FormModal";
import { createPipeline } from "./SkeyeingestPipelinesAPI";
import { extractMsg } from "../../../utils/errorUtils";

const PIPELINE_TYPES = [
  { label: "Data Collector", value: "DATA_COLLECTOR" },
  { label: "Data Collector Edge", value: "DATA_COLLECTOR_EDGE" },
  { label: "Microservice", value: "MICROSERVICE" },
];

export default function SkeyeingestCreatePipelineDialog({
  open,
  onClose,
  onSuccess,
  messageApi,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await createPipeline({ ...values, autoGeneratePipelineId: true });
      messageApi.success("Pipeline created successfully.");
      form.resetFields();
      onSuccess();
      onClose();
    } catch (error) {
      messageApi.error({
        content: extractMsg(error, "Failed to create pipeline"),
        key: "create-error",
      });
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormModal
      title="Create New Pipeline"
      open={open}
      onClose={onClose}
      onFinish={handleFinish}
      loading={loading}
      form={form}
      submitText="Create Pipeline"
    >
      <Form.Item
        name="pipelineLabel"
        label="Pipeline Title"
        rules={[{ required: true, message: "Title is required" }]}
      >
        <Input placeholder="Enter pipeline title" />
      </Form.Item>
      <Form.Item
        name="description"
        label="Description"
        rules={[{ required: true, message: "Description is required" }]}
      >
        <Input.TextArea rows={3} placeholder="Enter description" />
      </Form.Item>
      <Form.Item
        name="pipelineType"
        label="Pipeline Type"
        rules={[{ required: true, message: "Pipeline type is required" }]}
        initialValue="DATA_COLLECTOR"
      >
        <Select options={PIPELINE_TYPES} />
      </Form.Item>
    </FormModal>
  );
}
